import React from 'react';
import CrudPage from '../../components/CrudPage';
import { purchaseTransactionsApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'transactionId' },
  { header: 'Investor ID', field: 'investorId' },
  { header: 'Property ID', field: 'propertyId' },
  { header: 'Amount', field: 'amountTannit', render: (v) => v ? `£${v.toLocaleString()}` : '-' },
  { header: 'Description', field: 'description' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const formFields = [
  { name: 'investorId', label: 'Investor ID', type: 'text', required: true },
  { name: 'propertyId', label: 'Property ID', type: 'number', required: true },
  { name: 'amountTannit', label: 'Amount (Tannit)', type: 'number', required: true },
  { name: 'description', label: 'Description', type: 'textarea' },
];

const PurchaseTransactionsPage = () => (
  <CrudPage
    title="Purchase Transactions"
    subtitle="Manage purchase transactions"
    api={purchaseTransactionsApi}
    columns={columns}
    formFields={formFields}
    idField="transactionId"
  />
);

export default PurchaseTransactionsPage;
